import { Avatar, Tooltip, Tag } from 'antd';
import { Fragment } from 'react';
import Task from '../../../models/Task';
import UserTask from '../../../models/UserTask';
import { createInitialNames } from '../../../utils/functions';
import { taskStateUsers} from '../../../utils/functions';
import './AvatarStateUser.less';

interface AvatarUserStateProps {
    arrayUsers?:  UserTask[];
}

interface arrayNameUsers {
  initialNames?: string;
  fullName?: string;
  state?: number;
}

const AvatarStateUser = (props: AvatarUserStateProps) =>{

    const createInitialNamesFromUserArray = (arrayUsers?: UserTask[]) =>{
      if(arrayUsers){
          let arrayNameUsers: arrayNameUsers[] = []
            arrayUsers.forEach((task: Task)=>{
              let userInfo = {
                initialNames: createInitialNames(task.usuario?.nombre, task.usuario?.apellido),
                fullName: `${task.usuario?.nombre} ${task.usuario?.apellido}`,
                state: task.estado
              }
              arrayNameUsers.push(userInfo)
            })
            return arrayNameUsers;
        } else {
          return null
        }
      }

    return(
        <Fragment>
            {
                createInitialNamesFromUserArray(props.arrayUsers)?.map((infoUser, index)=>
                  {
                    return(
                        <div className={'container_avatar_user'} key={index}>
                            <Tooltip placement='top' title={infoUser.fullName} key={index}>
                            <Avatar key={index} style={{ backgroundColor: '#0078A0' }}>
                            {infoUser.initialNames}
                            </Avatar>
                          </Tooltip>
                          <div className={'container-tag'}>
                            <Tag className={taskStateUsers((infoUser.state as any)).className}>
                            {taskStateUsers((infoUser.state as any)).title}
                            </Tag>
                          </div>
                        </div>
                    ) 
                  }
                )
              }
        </Fragment>      
    )
}

export default AvatarStateUser